import { Component, Field } from '@contember/interface'

export const TechnologiesPreview = Component(() => (
	<div>
		<Field field="title" />
	</div>
))
